import React from "react";

export const DashboardIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6 3H4C3.44772 3 3 3.44772 3 4V7C3 7.55228 3.44772 8 4 8H6C6.55228 8 7 7.55228 7 7V4C7 3.44772 6.55228 3 6 3Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3H10C9.44772 3 9 3.44772 9 4V5C9 5.55228 9.44772 6 10 6H12C12.5523 6 13 5.55228 13 5V4C13 3.44772 12.5523 3 12 3Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10H4C3.44772 10 3 10.4477 3 11V12C3 12.5523 3.44772 13 4 13H6C6.55228 13 7 12.5523 7 12V11C7 10.4477 6.55228 10 6 10Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8H10C9.44772 8 9 8.44772 9 9V12C9 12.5523 9.44772 13 10 13H12C12.5523 13 13 12.5523 13 12V9C13 8.44772 12.5523 8 12 8Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClientUserIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12 12.6667C12 11.1939 10.2091 10 8 10C5.79086 10 4 11.1939 4 12.6667M8 8.00002C6.52724 8.00002 5.33333 6.80611 5.33333 5.33335C5.33333 3.86059 6.52724 2.66669 8 2.66669C9.47276 2.66669 10.6667 3.86059 10.6667 5.33335C10.6667 6.80611 9.47276 8.00002 8 8.00002Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClientLogIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.33464 2.66675H4.80143C4.0547 2.66675 3.68105 2.66675 3.39583 2.81207C3.14495 2.9399 2.94112 3.14373 2.81329 3.39461C2.66797 3.67983 2.66797 4.05347 2.66797 4.80021V11.2002C2.66797 11.9469 2.66797 12.3201 2.81329 12.6053C2.94112 12.8562 3.14495 13.0604 3.39583 13.1882C3.68077 13.3334 4.05396 13.3334 4.79924 13.3334H5.33464M5.33464 2.66675H11.2014C11.9482 2.66675 12.321 2.66675 12.6062 2.81207C12.8571 2.9399 13.0616 3.14373 13.1895 3.39461C13.3346 3.67955 13.3346 4.05274 13.3346 4.79802V11.2025C13.3346 11.9477 13.3346 12.3204 13.1895 12.6053C13.0616 12.8562 12.8571 13.0604 12.6062 13.1882C12.3213 13.3334 11.9486 13.3334 11.2034 13.3334H5.33464M5.33464 2.66675V13.3334M8.0013 7.33341H10.668M8.0013 5.33341H10.668"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LocateIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.33594 6.61523C3.33594 9.84978 6.16559 12.5246 7.41806 13.5501C7.59731 13.6969 7.68801 13.7712 7.82174 13.8088C7.92587 13.8381 8.07913 13.8381 8.18327 13.8088C8.31725 13.7711 8.40731 13.6976 8.58724 13.5502C9.83971 12.5247 12.6692 9.85008 12.6692 6.61553C12.6692 5.39145 12.1776 4.21737 11.3024 3.35181C10.4272 2.48626 9.24033 2 8.00266 2C6.76498 2 5.57794 2.48634 4.70277 3.35189C3.8276 4.21744 3.33594 5.39116 3.33594 6.61523Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66927 6C6.66927 6.73638 7.26622 7.33333 8.0026 7.33333C8.73898 7.33333 9.33594 6.73638 9.33594 6C9.33594 5.26362 8.73898 4.66667 8.0026 4.66667C7.26622 4.66667 6.66927 5.26362 6.66927 6Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClientTranIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14 7.99992L8 11.9999L2 7.99992M14 10.6666L8 14.6666L2 10.6666M14 5.33325L8 9.33325L2 5.33325L8 1.33325L14 5.33325Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClientEventIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.33464 2.66665H4.80143C4.0547 2.66665 3.68105 2.66665 3.39583 2.81197C3.14495 2.9398 2.94112 3.14363 2.81329 3.39451C2.66797 3.67973 2.66797 4.05337 2.66797 4.80011V5.33331M5.33464 2.66665H10.668M5.33464 2.66665V1.33331M10.668 2.66665H11.2014C11.9482 2.66665 12.321 2.66665 12.6062 2.81197C12.8571 2.9398 13.0616 3.14363 13.1895 3.39451C13.3346 3.67945 13.3346 4.05264 13.3346 4.79792V5.33331M10.668 2.66665V1.33331M2.66797 5.33331V11.2001C2.66797 11.9468 2.66797 12.32 2.81329 12.6052C2.94112 12.8561 3.14495 13.0603 3.39583 13.1881C3.68077 13.3333 4.05396 13.3333 4.79924 13.3333H11.2034C11.9486 13.3333 12.3213 13.3333 12.6062 13.1881C12.8571 13.0603 13.0616 12.8561 13.1895 12.6052C13.3346 12.3203 13.3346 11.9476 13.3346 11.2024V5.33331M2.66797 5.33331H13.3346M10.668 10.6666H10.6693L10.6693 10.668L10.668 10.6679V10.6666ZM8.0013 10.6666H8.00264L8.0026 10.668L8.0013 10.6679V10.6666ZM5.33464 10.6666H5.33597L5.33594 10.668L5.33464 10.6679V10.6666ZM10.6693 7.99998V8.00131L10.668 8.00128V7.99998H10.6693ZM8.0013 7.99998H8.00264L8.0026 8.00131L8.0013 8.00128V7.99998ZM5.33464 7.99998H5.33597L5.33594 8.00131L5.33464 8.00128V7.99998Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ServiceIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.59998 9.13335H2.15757M2.15757 9.13335H10.6424M2.15757 9.13335C2.1635 9.1059 2.17052 9.07869 2.17862 9.05181C2.19796 8.98766 2.22527 8.92596 2.28018 8.8024L3.10486 6.94689C3.2679 6.58003 3.34956 6.3965 3.47843 6.262C3.59234 6.1431 3.73205 6.05229 3.88695 5.99648C4.0622 5.93335 4.2631 5.93335 4.66456 5.93335H8.13521C8.53667 5.93335 8.73776 5.93335 8.91301 5.99648C9.06791 6.05229 9.20742 6.1431 9.32133 6.262C9.45011 6.39641 9.53161 6.57979 9.69444 6.94615L10.5224 8.80915C10.5754 8.92823 10.6023 8.98883 10.6213 9.05181C10.6294 9.07869 10.6364 9.1059 10.6424 9.13335M2.15757 9.13335C2.15092 9.16409 2.14563 9.19512 2.14169 9.22632C2.13331 9.2928 2.13331 9.36038 2.13331 9.49559V12.3333M10.6424 9.13335H11.2M10.6424 9.13335C10.6491 9.16409 10.6544 9.19512 10.6583 9.22632C10.6666 9.29239 10.6666 9.35958 10.6666 9.49316V12.3334M10.6666 12.3334L8.53331 12.3334M10.6666 12.3334V12.8666C10.6666 13.4557 10.1891 13.9333 9.59998 13.9333C9.01087 13.9333 8.53331 13.4558 8.53331 12.8667V12.3334M8.53331 12.3334L4.26664 12.3333M4.26664 12.3333H2.13331M4.26664 12.3333V12.8667C4.26664 13.4558 3.78908 13.9333 3.19998 13.9333C2.61087 13.9333 2.13331 13.4558 2.13331 12.8667V12.3333"
        stroke={fill}
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2 13.6V3.86089M13.2 3.86089H12.7304C12.327 3.86089 12 3.53387 12 3.13046V3.13046C12 2.72705 12.327 2.40002 12.7304 2.40002H13.6696C14.073 2.40002 14.4 2.72705 14.4 3.13046V3.13046C14.4 3.53387 14.073 3.86089 13.6696 3.86089H13.2Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SubscriptionIcon = ({ fill }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7.33331V10.5334C2 11.2802 2 11.6534 2.14532 11.9386C2.27316 12.1895 2.47698 12.3936 2.72786 12.5215C3.0128 12.6666 3.386 12.6666 4.13127 12.6666H11.8687C12.614 12.6666 12.9867 12.6666 13.2716 12.5215C13.5225 12.3936 13.727 12.1895 13.8548 11.9386C14 11.6536 14 11.281 14 10.5357V7.33331M2 7.33331V5.99998M2 7.33331H14M2 5.99998V5.46678C2 4.72004 2 4.34639 2.14532 4.06118C2.27316 3.81029 2.47698 3.60647 2.72786 3.47864C3.01308 3.33331 3.38673 3.33331 4.13346 3.33331H11.8668C12.6135 3.33331 12.9864 3.33331 13.2716 3.47864C13.5225 3.60647 13.727 3.81029 13.8548 4.06118C14 4.34611 14 4.71931 14 5.46459V5.99998M2 5.99998H14M4.66667 9.99998H7.33333M14 7.33331V5.99998"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HistoryIcon = ({ fill }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4.66667V8H11.3333M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HelpIcon = ({ fill }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.09766 6.04908C6.21152 5.69822 6.4201 5.38597 6.70052 5.14632C6.98094 4.90667 7.32253 4.74919 7.68685 4.69139C8.05117 4.63358 8.42415 4.6776 8.76497 4.81868C9.1058 4.95977 9.40097 5.1925 9.61784 5.49089C9.83471 5.78927 9.96459 6.14171 9.99358 6.50944C10.0226 6.87717 9.94923 7.24586 9.78179 7.57454C9.61436 7.90323 9.35958 8.17899 9.04507 8.37174C8.73056 8.5645 8.36888 8.66651 8 8.66651V9.33349M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14ZM8.0332 11.3333V11.4L7.9668 11.4001V11.3333H8.0332Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LogoutIcon = ({ fill }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 3.75V9.6875"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 4.23438C14.9922 5.04277 15.9399 6.23092 16.4518 7.62174C16.9637 9.01256 17.0126 10.5316 16.5909 11.9524C16.1693 13.3732 15.2999 14.6198 14.1121 15.5062C12.9244 16.3927 11.4821 16.8716 10 16.8716C8.51795 16.8716 7.07557 16.3927 5.88786 15.5062C4.70014 14.6198 3.83068 13.3732 3.40907 11.9524C2.98745 10.5316 3.03625 9.01256 3.5482 7.62174C4.06015 6.23092 5.00783 5.04277 6.25 4.23438"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VehicleIcon = ({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <path
        d="M2 7.333h.697m0 0h10.606m-10.606 0l.026-.102c.024-.08.058-.157.127-.312L3.881 4.6c.204-.459.306-.688.467-.856a1.33 1.33 0 0 1 .511-.332c.219-.079.47-.079.972-.079h4.338c.502 0 .753 0 .972.079a1.33 1.33 0 0 1 .51.332c.161.168.263.397.466.855l1.035 2.329.123.303.026.102m-10.606 0l-.02.116c-.01.083-.01.168-.01.337v3.547m10.636-4H14m-.697 0l.02.116a2.75 2.75 0 0 1 .01.334v3.55m0 0h-2.667m2.667 0V12c0 .736-.597 1.333-1.333 1.333s-1.333-.597-1.333-1.333v-.667m0 0H5.333m0 0H2.667m2.667 0V12c0 .736-.597 1.333-1.333 1.333S2.667 12.736 2.667 12v-.667"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IncidentIcon = ({ fill }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99967 14.6663C11.6663 14.6663 14.6663 11.6663 14.6663 7.99967C14.6663 4.33301 11.6663 1.33301 7.99967 1.33301C4.33301 1.33301 1.33301 4.33301 1.33301 7.99967C1.33301 11.6663 4.33301 14.6663 7.99967 14.6663Z"
        stroke={fill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5.33301V8.66634"
        stroke={fill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99609 10.667H8.00208"
        stroke={fill}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Add = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5 10H10M10 10H15M10 10V15M10 10V5"
        stroke={fill}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CarIcon = ({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
      <path
        d="M1.5 5.5h.523m0 0h7.955m-7.955 0l.02-.076a2.07 2.07 0 0 1 .095-.234l.773-1.74c.153-.344.229-.516.35-.642a1 1 0 0 1 .383-.249c.164-.059.353-.059.729-.059h3.254c.376 0 .565 0 .729.059a1 1 0 0 1 .383.249c.121.126.197.298.35.641l.776 1.747.093.227.02.076m-7.955 0l-.015.087C2 5.649 2 5.713 2 5.84V8.5m7.977-3h.523m-.523 0l.015.087a2.06 2.06 0 0 1 .008.25V8.5m0 0H8m2 0V9a1 1 0 1 1-2 0v-.5m0 0H4m0 0H2m2 0V9a1 1 0 1 1-2 0v-.5"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AdminDashboardIcon = ({ fill, stroke = "white" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3H4C3.44772 3 3 3.44772 3 4V7C3 7.55228 3.44772 8 4 8H6C6.55228 8 7 7.55228 7 7V4C7 3.44772 6.55228 3 6 3Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
      <path
        d="M12 3H10C9.44772 3 9 3.44772 9 4V5C9 5.55228 9.44772 6 10 6H12C12.5523 6 13 5.55228 13 5V4C13 3.44772 12.5523 3 12 3Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
      <path
        d="M6 10H4C3.44772 10 3 10.4477 3 11V12C3 12.5523 3.44772 13 4 13H6C6.55228 13 7 12.5523 7 12V11C7 10.4477 6.55228 10 6 10Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
      <path
        d="M12 8H10C9.44772 8 9 8.44772 9 9V12C9 12.5523 9.44772 13 10 13H12C12.5523 13 13 12.5523 13 12V9C13 8.44772 12.5523 8 12 8Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
    </svg>
  );
};

export const ServicesIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.59961 9.13335H2.1572M2.1572 9.13335H10.642M2.1572 9.13335C2.16314 9.1059 2.17015 9.07869 2.17826 9.05181C2.19759 8.98766 2.2249 8.92596 2.27982 8.8024L3.10449 6.94689C3.26754 6.58003 3.3492 6.3965 3.47806 6.262C3.59197 6.1431 3.73168 6.05229 3.88659 5.99648C4.06183 5.93335 4.26273 5.93335 4.66419 5.93335H8.13485C8.53631 5.93335 8.7374 5.93335 8.91264 5.99648C9.06755 6.05229 9.20706 6.1431 9.32096 6.262C9.44974 6.39641 9.53125 6.57979 9.69407 6.94615L10.5221 8.80915C10.575 8.92823 10.6019 8.98883 10.6209 9.05181C10.629 9.07869 10.6361 9.1059 10.642 9.13335M2.1572 9.13335C2.15055 9.16409 2.14526 9.19512 2.14133 9.22632C2.13294 9.2928 2.13294 9.36038 2.13294 9.49559V12.3333M10.642 9.13335H11.1996M10.642 9.13335C10.6487 9.16409 10.654 9.19512 10.6579 9.22632C10.6663 9.29239 10.6663 9.35958 10.6663 9.49316V12.3334M10.6663 12.3334L8.53294 12.3334M10.6663 12.3334V12.8666C10.6663 13.4557 10.1887 13.9333 9.59961 13.9333C9.01051 13.9333 8.53294 13.4558 8.53294 12.8667V12.3334M8.53294 12.3334L4.26628 12.3333M4.26628 12.3333H2.13294M4.26628 12.3333V12.8667C4.26628 13.4558 3.78871 13.9333 3.19961 13.9333C2.61051 13.9333 2.13294 13.4558 2.13294 12.8667V12.3333"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2 13.6V3.86089M13.2 3.86089H12.7304C12.327 3.86089 12 3.53387 12 3.13046V3.13046C12 2.72705 12.327 2.40002 12.7304 2.40002H13.6696C14.073 2.40002 14.4 2.72705 14.4 3.13046V3.13046C14.4 3.53387 14.073 3.86089 13.6696 3.86089H13.2Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12.6666C12 11.1939 10.2091 9.99996 8 9.99996C5.79086 9.99996 4 11.1939 4 12.6666M8 7.99996C6.52724 7.99996 5.33333 6.80605 5.33333 5.33329C5.33333 3.86053 6.52724 2.66663 8 2.66663C9.47276 2.66663 10.6667 3.86053 10.6667 5.33329C10.6667 6.80605 9.47276 7.99996 8 7.99996Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomerIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 8.00004L7 12L1 8.00004M13 10.6667L7 14.6667L1 10.6667M13 5.33337L7 9.33337L1 5.33337L7 1.33337L13 5.33337Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LocationIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33398 6.61523C3.33398 9.84978 6.16363 12.5246 7.41611 13.5501C7.59536 13.6969 7.68606 13.7712 7.81979 13.8088C7.92392 13.8381 8.07718 13.8381 8.18131 13.8088C8.3153 13.7711 8.40536 13.6976 8.58529 13.5502C9.83776 12.5247 12.6673 9.85008 12.6673 6.61553C12.6673 5.39145 12.1756 4.21737 11.3005 3.35181C10.4253 2.48626 9.23838 2 8.0007 2C6.76303 2 5.57599 2.48634 4.70082 3.35189C3.82565 4.21744 3.33398 5.39116 3.33398 6.61523Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66732 6C6.66732 6.73638 7.26427 7.33333 8.00065 7.33333C8.73703 7.33333 9.33398 6.73638 9.33398 6C9.33398 5.26362 8.73703 4.66667 8.00065 4.66667C7.26427 4.66667 6.66732 5.26362 6.66732 6Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AdminVehicleIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5.33337H1.69699M1.69699 5.33337H12.303M1.69699 5.33337C1.70441 5.29906 1.71318 5.26505 1.72331 5.23145C1.74748 5.15126 1.78162 5.07414 1.85026 4.91969L2.8811 2.6003C3.08491 2.14173 3.18699 1.91231 3.34807 1.74418C3.49045 1.59557 3.66509 1.48204 3.85872 1.41229C4.07778 1.33337 4.3289 1.33337 4.83073 1.33337H9.16905C9.67087 1.33337 9.92223 1.33337 10.1413 1.41229C10.3349 1.48204 10.5093 1.59557 10.6517 1.74418C10.8127 1.91219 10.9145 2.14143 11.1181 2.59938L12.1531 4.92813C12.2192 5.07698 12.2529 5.15273 12.2766 5.23145C12.2868 5.26505 12.2956 5.29906 12.303 5.33337M1.69699 5.33337C1.68868 5.3718 1.68207 5.41059 1.67715 5.44959C1.66667 5.53268 1.66667 5.61716 1.66667 5.78617V9.33337M12.303 5.33337H13M12.303 5.33337C12.3114 5.3718 12.318 5.41059 12.3229 5.44959C12.3333 5.53218 12.3333 5.61616 12.3333 5.78313V9.33345M12.3333 9.33345L9.66667 9.33343M12.3333 9.33345V9.99997C12.3333 10.7363 11.7364 11.3334 11 11.3334C10.2636 11.3334 9.66667 10.7364 9.66667 10V9.33343M9.66667 9.33343L4.33333 9.33337M4.33333 9.33337H1.66667M4.33333 9.33337V10C4.33333 10.7364 3.73638 11.3334 3 11.3334C2.26362 11.3334 1.66667 10.7364 1.66667 10V9.33337"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClientsIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 11.3333C13 10.1722 11.8869 9.18448 10.3333 8.8184M9 11.3334C9 9.86062 7.20914 8.66671 5 8.66671C2.79086 8.66671 1 9.86062 1 11.3334M9 6.66671C10.4728 6.66671 11.6667 5.4728 11.6667 4.00004C11.6667 2.52728 10.4728 1.33337 9 1.33337M5 6.66671C3.52724 6.66671 2.33333 5.4728 2.33333 4.00004C2.33333 2.52728 3.52724 1.33337 5 1.33337C6.47276 1.33337 7.66667 2.52728 7.66667 4.00004C7.66667 5.4728 6.47276 6.66671 5 6.66671Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MembershipsIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3333 11.3334C10.3333 10.2288 8.84095 9.33337 7 9.33337C5.15905 9.33337 3.66667 10.2288 3.66667 11.3334M13 9.33362C13 8.5135 12.1773 7.80866 11 7.50004M1 9.33362C1 8.5135 1.82273 7.80866 3 7.50004M11 4.82411C11.4092 4.4579 11.6667 3.92571 11.6667 3.33337C11.6667 2.2288 10.7712 1.33337 9.66667 1.33337C9.15443 1.33337 8.68717 1.52594 8.33333 1.84264M3 4.82411C2.59083 4.4579 2.33333 3.92571 2.33333 3.33337C2.33333 2.2288 3.22876 1.33337 4.33333 1.33337C4.84557 1.33337 5.31283 1.52594 5.66667 1.84264M7 7.33337C5.89543 7.33337 5 6.43794 5 5.33337C5 4.2288 5.89543 3.33337 7 3.33337C8.10457 3.33337 9 4.2288 9 5.33337C9 6.43794 8.10457 7.33337 7 7.33337Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogsIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33268 0.666626H2.79948C2.05274 0.666626 1.6791 0.666626 1.39388 0.811951C1.143 0.939782 0.939171 1.14361 0.81134 1.39449C0.666016 1.67971 0.666016 2.05335 0.666016 2.80009V9.20009C0.666016 9.94683 0.666016 10.32 0.81134 10.6052C0.939171 10.8561 1.143 11.0603 1.39388 11.1881C1.67882 11.3333 2.05201 11.3333 2.79729 11.3333H3.33268M3.33268 0.666626H9.19948C9.94622 0.666626 10.3191 0.666626 10.6043 0.811951C10.8552 0.939782 11.0597 1.14361 11.1875 1.39449C11.3327 1.67943 11.3327 2.05262 11.3327 2.7979V9.20234C11.3327 9.94762 11.3327 10.3203 11.1875 10.6052C11.0597 10.8561 10.8552 11.0603 10.6043 11.1881C10.3193 11.3333 9.94668 11.3333 9.20141 11.3333H3.33268M3.33268 0.666626V11.3333M5.99935 5.33329H8.66602M5.99935 3.33329H8.66602"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AuditIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6.66667L7.33333 9.33333L6 8M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReportsIcon = ({ fill, stroke = "white" }) => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.00065 10.3333H8.00065M4.00065 8.33333H8.00065M6.66757 1.00058C6.60388 1 6.53224 1 6.45046 1H3.46745C2.72071 1 2.34706 1 2.06185 1.14533C1.81097 1.27316 1.60714 1.47698 1.47931 1.72786C1.33398 2.01308 1.33398 2.38673 1.33398 3.13346V10.8668C1.33398 11.6135 1.33398 11.9867 1.47931 12.2719C1.60714 12.5228 1.81097 12.727 2.06185 12.8548C2.34679 13 2.71999 13 3.46528 13L8.53605 13C9.28132 13 9.65398 13 9.93891 12.8548C10.1898 12.727 10.3943 12.5228 10.5221 12.2719C10.6673 11.987 10.6673 11.6143 10.6673 10.8691V5.21712C10.6673 5.13535 10.6672 5.06369 10.6667 5M6.66757 1.00058C6.85787 1.00232 6.9778 1.00938 7.09277 1.03698C7.22882 1.06964 7.35922 1.12351 7.47852 1.19661C7.61303 1.27904 7.72853 1.39454 7.95898 1.625L10.0426 3.70866C10.2732 3.93926 10.3879 4.05424 10.4704 4.1888C10.5435 4.30809 10.5975 4.43817 10.6302 4.57422C10.6578 4.68919 10.6649 4.8097 10.6667 5M6.66757 1.00058L6.66732 2.86681C6.66732 3.61354 6.66732 3.98677 6.81264 4.27198C6.94047 4.52287 7.1443 4.72699 7.39518 4.85482C7.68012 5 8.05332 5 8.7986 5H10.6667"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ConfigIcon = ({ stroke = "white" }) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5666 4.94862L13.3225 4.8128C13.2846 4.79171 13.2659 4.78113 13.2476 4.77016C13.0656 4.6611 12.9121 4.51042 12.8001 4.33015C12.7889 4.31201 12.7782 4.29299 12.7565 4.2554C12.7348 4.21785 12.7238 4.19882 12.7138 4.17999C12.6133 3.99244 12.559 3.78344 12.5557 3.57071C12.5554 3.54932 12.5555 3.52747 12.5562 3.48403L12.561 3.20052C12.5686 2.74684 12.5724 2.51929 12.5087 2.31508C12.452 2.13369 12.3573 1.96662 12.2308 1.82483C12.0878 1.66457 11.8898 1.55023 11.4935 1.32184L11.1643 1.13214C10.7691 0.904386 10.5714 0.790472 10.3615 0.747045C10.1759 0.708625 9.98435 0.710406 9.79939 0.751928C9.59063 0.798791 9.39543 0.915674 9.00524 1.14931L9.00303 1.15037L8.76715 1.29161C8.72985 1.31394 8.71097 1.3252 8.69228 1.33559C8.50676 1.43874 8.29965 1.49577 8.08749 1.50258C8.06611 1.50327 8.04436 1.50327 8.00087 1.50327C7.95765 1.50327 7.93497 1.50327 7.91363 1.50258C7.70102 1.49574 7.49348 1.4384 7.30767 1.33482C7.28895 1.32439 7.27042 1.31304 7.23305 1.2906L6.99566 1.14809C6.60282 0.912242 6.4061 0.794143 6.19618 0.747045C6.01047 0.705377 5.81825 0.704224 5.63194 0.743139C5.42157 0.787078 5.22384 0.901837 4.82839 1.13136L4.82663 1.13214L4.50152 1.32083L4.49792 1.32303C4.10603 1.55048 3.90961 1.66448 3.7678 1.82409C3.64196 1.96573 3.5479 2.13254 3.4916 2.31345C3.42796 2.51794 3.43135 2.74597 3.43902 3.2018L3.44378 3.4849C3.44451 3.52778 3.44576 3.54908 3.44544 3.57016C3.44229 3.78333 3.38724 3.99276 3.2865 4.18064C3.27653 4.19922 3.2658 4.2178 3.24436 4.25492C3.22291 4.29206 3.21252 4.31053 3.20139 4.32845C3.08891 4.50968 2.93476 4.66124 2.75155 4.77048C2.73343 4.78129 2.71433 4.79168 2.67681 4.81248L2.43577 4.94605C2.03472 5.1683 1.83425 5.27952 1.68837 5.4378C1.55932 5.57782 1.46183 5.7439 1.40233 5.92478C1.33506 6.12925 1.33512 6.35852 1.33616 6.81703L1.33701 7.19178C1.33804 7.64723 1.33946 7.8748 1.40688 8.07788C1.46652 8.25755 1.5633 8.42265 1.69163 8.56182C1.83668 8.71914 2.03516 8.82967 2.43316 9.05108L2.67206 9.18398C2.71271 9.2066 2.73317 9.21776 2.75278 9.22957C2.93432 9.33889 3.08726 9.49003 3.19879 9.67022C3.21084 9.68969 3.2224 9.7099 3.24553 9.7503C3.26837 9.79021 3.28006 9.81016 3.29062 9.83016C3.38841 10.0153 3.44076 10.221 3.44433 10.4303C3.44471 10.4529 3.44438 10.4758 3.44361 10.5218L3.43902 10.7935C3.4313 11.2509 3.42794 11.4798 3.49195 11.6849C3.54858 11.8663 3.64323 12.0333 3.76975 12.1751C3.91277 12.3354 4.11103 12.4496 4.50738 12.678L4.83652 12.8677C5.23175 13.0955 5.4293 13.2092 5.63913 13.2527C5.82476 13.2911 6.01643 13.2896 6.20139 13.2481C6.41044 13.2011 6.60632 13.0838 6.99762 12.8495L7.2335 12.7083C7.27082 12.686 7.28971 12.6748 7.30841 12.6644C7.49393 12.5612 7.70082 12.5039 7.91298 12.4971C7.93436 12.4964 7.95611 12.4964 7.9996 12.4964C8.04319 12.4964 8.06492 12.4964 8.08635 12.4971C8.29896 12.5039 8.50712 12.5614 8.69293 12.665C8.70928 12.6741 8.72566 12.684 8.75442 12.7012L9.00518 12.8518C9.39808 13.0877 9.59438 13.2054 9.80431 13.2525C9.99002 13.2942 10.1824 13.2959 10.3687 13.257C10.579 13.213 10.7771 13.0981 11.1724 12.8687L11.5024 12.6771C11.8945 12.4495 12.0912 12.3354 12.233 12.1758C12.3589 12.0341 12.453 11.8674 12.5093 11.6865C12.5725 11.4835 12.5687 11.2572 12.5611 10.8079L12.5562 10.5149C12.5555 10.4721 12.5554 10.4507 12.5557 10.4297C12.5589 10.2165 12.613 10.0069 12.7138 9.81904C12.7237 9.80049 12.7345 9.78177 12.7559 9.74477C12.7773 9.70764 12.7885 9.68912 12.7996 9.6712C12.9121 9.48997 13.0664 9.33828 13.2496 9.22903C13.2675 9.21836 13.2859 9.20815 13.3225 9.18785L13.3238 9.18726L13.5648 9.05369C13.9659 8.83144 14.1667 8.7201 14.3126 8.56182C14.4417 8.42181 14.539 8.25595 14.5985 8.07507C14.6654 7.87181 14.6649 7.64386 14.6638 7.19071L14.663 6.80792C14.6619 6.35247 14.6614 6.12493 14.594 5.92185C14.5343 5.74218 14.437 5.57707 14.3087 5.4379C14.1638 5.28074 13.965 5.17017 13.5678 4.94919L13.5666 4.94862Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33355 6.99997C5.33355 8.47273 6.52746 9.66664 8.00022 9.66664C9.47298 9.66664 10.6669 8.47273 10.6669 6.99997C10.6669 5.52722 9.47298 4.33331 8.00022 4.33331C6.52746 4.33331 5.33355 5.52722 5.33355 6.99997Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MetricsIcon = ({ stroke = "white" }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.23954 7.74219H5.47288C5.05288 7.74219 4.71289 8.08216 4.71289 8.50216V11.9155H7.23954V7.74219V7.74219Z"
      stroke={stroke}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00771 4.70898H7.99436C7.57436 4.70898 7.23438 5.04899 7.23438 5.46899V11.909H9.76105V5.46899C9.76105 5.04899 9.42771 4.70898 9.00771 4.70898Z"
      stroke={stroke}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5323 8.875H9.76562V11.9084H12.2923V9.63501C12.2856 9.21501 11.9456 8.875 11.5323 8.875Z"
      stroke={stroke}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.50065 14.9759H10.5007C13.834 14.9759 15.1673 13.6426 15.1673 10.3092V6.30924C15.1673 2.97591 13.834 1.64258 10.5007 1.64258H6.50065C3.16732 1.64258 1.83398 2.97591 1.83398 6.30924V10.3092C1.83398 13.6426 3.16732 14.9759 6.50065 14.9759Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FeedbackIcon = ({ stroke = "white" }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.76576 7.34958L2.26291 7.29629C2.24181 7.09942 2.22852 6.90963 2.22852 6.71675C2.22852 3.32988 5.17676 0.523438 8.86435 0.523438C12.5519 0.523438 15.5002 3.32988 15.5002 6.71675C15.5002 8.58037 14.6388 10.2977 13.103 11.4802C12.9626 11.5882 12.8899 11.7626 12.9119 11.9384L13.1647 13.9599C13.1648 13.9605 13.1649 13.961 13.1649 13.9615C13.2017 14.2788 13.0646 14.5686 12.8016 14.7397C12.6709 14.8234 12.5188 14.8682 12.3727 14.8682C12.2286 14.8682 12.0882 14.8314 11.9617 14.7546L11.9617 14.7546L11.9574 14.752L8.97049 12.98C8.89675 12.9363 8.813 12.9122 8.72728 12.9102C8.42942 12.9031 8.13814 12.882 7.86588 12.8412L7.86498 12.841C7.83944 12.8372 7.8202 12.8214 7.81146 12.7987C7.80629 12.7852 7.80662 12.7765 7.80755 12.7712C7.80851 12.7657 7.81137 12.7568 7.82121 12.7453C8.38916 12.083 8.68652 11.2831 8.68652 10.4319C8.68652 8.31756 6.83815 6.66345 4.6484 6.66345C3.82861 6.66345 3.03356 6.88888 2.35968 7.33087C2.34804 7.33791 2.33754 7.34066 2.32862 7.34128C2.32026 7.34187 2.31014 7.34081 2.29816 7.33597C2.28727 7.3301 2.27811 7.32199 2.27177 7.31342C2.26514 7.30448 2.26304 7.29721 2.26246 7.29224L1.76576 7.34958ZM1.76576 7.34958C1.78811 7.54316 1.91473 7.70698 2.08605 7.78887L13.0729 15.1597C13.4974 14.8843 13.7209 14.4078 13.6613 13.9015L13.408 11.8763C15.0616 10.6032 16.0002 8.74187 16.0002 6.71675C16.0002 3.02388 12.7973 0.0234375 8.86435 0.0234375C4.93145 0.0234375 1.72852 3.02388 1.72852 6.71675C1.72852 6.93266 1.74342 7.14111 1.76576 7.34958ZM8.40972 12.0621C8.32935 12.2228 8.34136 12.4143 8.44118 12.5636C8.53864 12.7095 8.70518 12.7933 8.87979 12.7853C8.88626 12.7896 8.89284 12.7937 8.8995 12.7976L12.0157 14.6486C12.1401 14.7256 12.2826 14.7631 12.4293 14.7505C12.5657 14.7388 12.6709 14.687 12.7393 14.6426C12.8905 14.5464 13.0944 14.3192 13.0472 13.9706L12.7579 11.6271C12.7553 11.5957 12.7687 11.572 12.7842 11.5598C14.4259 10.4071 15.3829 8.63695 15.3829 6.70184C15.3829 3.31575 12.4262 0.625327 8.86435 0.625327C5.43599 0.625327 2.5674 3.12316 2.35436 6.33374C2.34305 6.50411 2.41947 6.66847 2.55703 6.76964C2.69458 6.8708 2.87425 6.89478 3.03351 6.83322C3.53678 6.63871 4.07913 6.5318 4.64095 6.5318C6.96312 6.5318 8.79638 8.30114 8.79638 10.417H8.79634L8.79641 10.4227C8.8029 10.9932 8.667 11.5478 8.40972 12.0621ZM12.5442 13.7997L12.5378 13.7958C12.54 13.7971 12.5421 13.7984 12.5442 13.7997Z"
      stroke={stroke}
    />
    <path
      d="M2.19481 15.4405L2.19252 15.4391C2.01607 15.3254 1.92732 15.1382 1.94895 14.9363L2.09731 13.7944C2.11962 13.6227 2.05149 13.4517 1.91722 13.3423C1.02309 12.6141 0.5 11.5406 0.5 10.4243C0.5 9.15084 1.16608 7.95143 2.30217 7.22759L2.30218 7.22761L2.30605 7.22509C2.99033 6.78018 3.80401 6.53906 4.65543 6.53906C6.97759 6.53906 8.81085 8.3084 8.81085 10.4243C8.81085 11.2863 8.49696 12.1394 7.91775 12.817L7.9177 12.8169L7.91218 12.8236C7.16773 13.7258 6.04712 14.2621 4.79574 14.3024C4.71138 14.3051 4.62907 14.3292 4.5565 14.3723L2.74009 15.4512C2.73994 15.4513 2.73978 15.4514 2.73962 15.4515C2.65697 15.5002 2.56695 15.5232 2.47297 15.5232C2.37341 15.5232 2.28255 15.4977 2.19481 15.4405ZM2.84 15.247L4.61797 14.1911C4.63678 14.1803 4.64742 14.1782 4.6494 14.1779C5.88087 14.1775 7.06048 13.6511 7.81766 12.7326C8.37958 12.0677 8.6861 11.2707 8.6861 10.4169C8.6861 8.3092 6.83695 6.65586 4.64798 6.65586C3.82735 6.65586 3.0315 6.8817 2.35715 7.32461C1.2716 8.02089 0.609857 9.17133 0.609857 10.4243C0.609857 11.6299 1.20243 12.7264 2.2256 13.4264C2.23527 13.4333 2.24172 13.4416 2.24592 13.451C2.25005 13.4602 2.25283 13.4724 2.25169 13.4876L2.08878 14.7532C2.06437 14.9429 2.15027 15.1299 2.31007 15.2349C2.46987 15.3399 2.67558 15.3446 2.84 15.247Z"
      stroke={stroke}
    />
    <path d="M6 5.02344H12" stroke={stroke} />
    <path d="M8 8.02344L12 8.02344" stroke={stroke} />
    <path d="M3 9.52344H6" stroke={stroke} />
    <path d="M4 11.5234L6 11.5234" stroke={stroke} />
  </svg>
);
